import axios from "axios";
import { ec2Api, apiKey } from "../settings/appSetting";
import { imageCompress } from "./utils";
import { conf } from '../settings'

const baseUrl = ec2Api.debug ? ec2Api.endpoint_debug : ec2Api.endpoint_public
/**
 * @formData_upload
 *  {
 *    file,
 *    opiton.size,   
 *            // FHD    1920 * 1080
 *            // HD     1080 * 720  - default
 *            // SD     640 * 480 
 *            // AVATAR 240 * 240
 *    option.type, 
 *            // portrait
 *            // landscape - default
 *  }
 */

export const imageSizes = {
  FHD: "FHD",
  HD: "HD",
  SD: "SD",
  AVATAR: "AVATAR",
}

export const uploadFormData = async ({ file, option, shopId }) => {

  const sizeValue = {
    "FHD": { w: 1920, h: 1440 },
    "HD": { w: 1080, h: 810 }, // default HD landscape
    "SD": { w: 800, h: 600 },
    "AVATAR": { w: 240, h: 240 },
  }

  const formData = new FormData();
  formData.append('file', file)
  formData.append('filename', file.name)

  if (option) {
    if (Object.keys(sizeValue).includes(option.size)) {
      if (option.type === "portrait") {
        formData.append('width', sizeValue[option.size].h)
        formData.append('height', sizeValue[option.size].w)
      } else {
        formData.append('width', sizeValue[option.size].w)
        formData.append('height', sizeValue[option.size].h)
      }
    } 
    
    // 
    // default size
    // 
    else {
      formData.append('width', sizeValue["HD"].w)
      formData.append('height', sizeValue["HD"].h)
    }
  }
  if (shopId) {
    formData.append('shopId', shopId)
  }


  try {
    const headers = { 'x-taptag-key': apiKey }
    const url = baseUrl + "/aws/s3/file-upload/image"
    let res = await axios.post(url, formData, { headers })

    // if (res.status !== 200 && res.status !== 201) throw new Error("UploadFile Error");
    return res.data;
  } catch (e) {
    return { err: { message: e.message } };
  }
}

export const uploadImagefile = async ({ file, option, shopId }) => {
  try {
    if (!file) throw new Error("No File");
    const maxSize = conf.MAX_FILE_SIZE

    let resizedImg = file
    if (file.size > maxSize) {
      resizedImg = await imageCompress({
        image: file,
        maxSizeMB: 5,
        maxWidthOrHeight: 1920
      })
      if (!resizedImg) throw new Error("이미지 처리에 문제가 발생하였습니다. at imageCommpress");
      resizedImg.name = file.name
    }

    return await uploadFormData({ file: resizedImg, option, shopId });

  } catch (e) {
    return { err: { message: e.message } }
  }
}
